import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-branch-report',
  templateUrl: './branch-report.component.html',
  styleUrls: ['./branch-report.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    LmsModalFrameComponent,
  ],
})
export class BranchReportComponent {
  branchReportList: any[] = [];
  areaName: string = '';
  startDate: string = '';
  endDate: string = '';
  fileName = '';

  @ViewChild('TABLE') table: ElementRef;

  config: PaginationInstance = {
    id: 'area-report-pager',
    itemsPerPage: 15,
    currentPage: 1,
  };

  constructor(
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<BranchReportComponent>,
  ) {}

  exportToExcel(): void {
    this.fileName = `BranchReportByArea_${this.areaName}_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    this.global_utility.startLoading('Exporting data to Excel...');
    loadXLSX()
      .then((XLSX) => {
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Branch Report');
        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to export Excel: ' + err);
      });
  }

  close() {
    this.dialogRef.close();
  }
}
